import { ServicesContainer } from '@/services';
import { LinkClickEvent } from '@/services/analytics/events';
import { AnalyticsEventType } from '@/services/analytics/platforms/adobe-analytics/models';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { AdobeBaseEvent } from './adobe-base-event';

export class AdobeLinkClickEvent extends AdobeBaseEvent {
  event = AnalyticsEventType.LinkClicked;

  constructor(event: LinkClickEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);
    this.web.webInteraction = event.webInteraction;
  }
}
